import { useState } from 'react';
import PrivacyModal from './PrivacyModal';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefono: '',
    oggetto: '',
    messaggio: '',
    privacy: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [privacyError, setPrivacyError] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? (target as HTMLInputElement).checked : target.value;
    const name = target.name;

    if (name === 'privacy') {
      setPrivacyError(false);
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.privacy) {
      setPrivacyError(true);
      return;
    }

    setPrivacyError(false);
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nome', formData.nome);
      formBody.append('email', formData.email);
      formBody.append('telefono', formData.telefono);
      formBody.append('oggetto', formData.oggetto);
      formBody.append('messaggio', formData.messaggio);

      const response = await fetch('https://readdy.ai/api/form/d5g37ngf0tcnoht874b0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefono: '',
          oggetto: '',
          messaggio: '',
          privacy: false
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <PrivacyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
      />

      <div className="lg:col-span-3 bg-white p-12 lg:p-16 flex flex-col justify-center">
        <form onSubmit={handleSubmit} id="contact-form" data-readdy-form>
          <div className="mb-8">
            <h3 className="text-3xl font-serif text-[#2D5016] mb-2">
              Inviaci un Messaggio
            </h3>
            <p className="text-gray-600">
              Compila il form e ti risponderemo al più presto
            </p>
          </div>

          <div className="space-y-6">
            <div>
              <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                Nome Completo *
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-[#8B9D7C] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D5016] text-sm"
                placeholder="Il tuo nome"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-[#8B9D7C] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D5016] text-sm"
                  placeholder="tua@email.it"
                />
              </div>

              <div>
                <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2">
                  Telefono
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-[#8B9D7C] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D5016] text-sm"
                  placeholder="+39 123 456 7890"
                />
              </div>
            </div>

            <div>
              <label htmlFor="oggetto" className="block text-sm font-medium text-gray-700 mb-2">
                Oggetto *
              </label>
              <select
                id="oggetto"
                name="oggetto"
                value={formData.oggetto}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-[#8B9D7C] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D5016] text-sm cursor-pointer"
              >
                <option value="">Seleziona un oggetto</option>
                <option value="Informazioni Prodotti">Informazioni Prodotti</option>
                <option value="Ordine">Ordine</option>
                <option value="Spedizione">Spedizione</option>
                <option value="Collaborazioni">Collaborazioni</option>
                <option value="Altro">Altro</option>
              </select>
            </div>

            <div>
              <label htmlFor="messaggio" className="block text-sm font-medium text-gray-700 mb-2">
                Messaggio *
              </label>
              <textarea
                id="messaggio"
                name="messaggio"
                value={formData.messaggio}
                onChange={handleChange}
                required
                maxLength={500}
                rows={6}
                className="w-full px-4 py-3 border border-[#8B9D7C] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D5016] text-sm resize-none"
                placeholder="Scrivi qui il tuo messaggio..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">
                Massimo 500 caratteri ({formData.messaggio.length}/500)
              </p>
            </div>

            <div>
              <div className="flex items-start">
                <input
                  type="checkbox"
                  id="privacy"
                  name="privacy"
                  checked={formData.privacy}
                  onChange={handleChange}
                  className={`mt-1 mr-3 cursor-pointer accent-[#2D5016] ${privacyError ? 'outline outline-2 outline-red-500 rounded' : ''}`}
                />
                <label htmlFor="privacy" className="text-sm text-gray-600">
                  Ho letto e accetto l&apos;
                  <button
                    type="button"
                    onClick={() => setIsPrivacyModalOpen(true)}
                    className="text-[#2D5016] hover:underline cursor-pointer font-medium"
                  >
                    Informativa sul trattamento dei dati personali
                  </button>
                  {' '}ai sensi dell&apos;art. 13 del Reg. (UE) n. 2016/679 e autorizzo il trattamento dei miei dati personali *
                </label>
              </div>
              {privacyError && (
                <p className="mt-2 text-xs text-red-600 flex items-center">
                  <i className="ri-error-warning-line mr-1"></i>
                  Devi accettare l&apos;informativa sul trattamento dei dati personali per continuare.
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full px-8 py-4 bg-[#2D5016] text-white rounded-full text-base font-medium hover:bg-[#3d6b1e] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap flex items-center justify-center cursor-pointer"
            >
              {isSubmitting ? (
                <>
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  Invio in corso...
                </>
              ) : (
                <>
                  Invia Messaggio
                  <i className="ri-send-plane-fill ml-2"></i>
                </>
              )}
            </button>

            {submitStatus === 'success' && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-green-800 text-sm flex items-center">
                  <i className="ri-check-line mr-2"></i>
                  Messaggio inviato con successo! Ti risponderemo al più presto.
                </p>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-800 text-sm flex items-center">
                  <i className="ri-error-warning-line mr-2"></i>
                  Si è verificato un errore. Riprova più tardi.
                </p>
              </div>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactForm;
